import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
import { Link } from 'react-router-dom';
import Table from '../../core/common/dataTable/index'; 
import api from '../../api';
import { useHeaderFilters } from '../../context/HeaderFilterContext';
import useDynamicPageSize from '../../useDynamicPageSize';
import Footer from '../../Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast, ToastContainer } from "react-toastify";


type PayHeaderType = {
  id: number;
  type: string;
  name: string;
  category: string;
  code: string;
  description: string;
  amount: string;
};
type ModalMode = "add" | "edit";

const PayHeader: React.FC = () => {
  // Pagination state
  const { setFilters } = useHeaderFilters();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = useDynamicPageSize();
   const isInitialFetch = useRef(true);
   const [totalItems, setTotalItems] = useState<number>(0);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [loading, setLoading] = useState(true);

useLayoutEffect(() => {
  if (pageSize === 0) return; // Prevent setting height too early
  const calculateHeight = () => {
    const baseOffset = 194;
    const extraOffset = window.innerWidth <= 991 ? -43 : -81;
    const fixedOffset = baseOffset + extraOffset;
  
    const newHeight = window.innerHeight - fixedOffset;
  
    console.log('Calculated table height:', newHeight);
    console.log('fixedOffset:', fixedOffset);
    console.log('window.innerHeight:', window.innerHeight);
    console.log("totalItems :",totalItems);
     console.log("pagesize :",pageSize);
    setTableHeight(newHeight);
  };
   calculateHeight(); 
  window.addEventListener("resize", calculateHeight); // respond to window size changes

    return () => window.removeEventListener("resize", calculateHeight); // cleanup on unmount
  }, []);

  // Data state

  const [payHeader, setPayHeader] = useState<PayHeaderType[]>([]);
  // Form state
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    description: "",
    type: "",
    category: "",
    amount: "",
  });
  const [modalMode, setModalMode] = useState<ModalMode>("add");
  const [editId, setEditId] = useState<number | null>(null);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  // Validation error state
  const [formError, setFormError] = useState<{
    name?: string;
    code?: string;
    description?: string;
    type?: string;
    category?: string;
    amount?: string;
  }>({});

  // Fetch payheader with pagination
  const fetchPayHeader = async () => {
    try {
      setLoading(true);
      const res = await api<any>("/pay-header-list", {
        method: "POST",
        body: { currentPage, pageSize: pageSize },
      });
      console.log("Raw API response:", res);
      const apiData = res?.payheader;
      setPayHeader(
        apiData.data.map((rec: any) => ({
          id: rec.id,
          type: rec.type,
          category: rec.category,
          name: rec.name,
          code: rec.code,
          description: rec.description,
          amount: rec.amount,
        }))
      );
      setTotalItems(apiData.total);
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
     if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    console.log('Fetching pay headers: currentPage =', currentPage, 'pageSize =', pageSize);
    fetchPayHeader();
  }, [currentPage, pageSize]);

  useEffect(() => {
    const PayHeaderFilters = () => (
      <div className="px-2 px-md-2">
        <div className="payheader-filters d-flex align-items-center flex-wrap ">
          <div className="d-flex align-items-center gap-2">
            <button
              className="btn btn-outline-primary add_btn_size"
              onClick={() => openModal("add")}
            >
              <i className="ti ti-circle-plus" />
            </button>
          </div>
        </div>
      </div>
    );

    setFilters(<PayHeaderFilters />);
    return () => {
      console.log("cleaning up filters");
      setFilters(null);
    };
  }, []);

  // open modal (add or edit)
  const openModal = (mode: ModalMode, rec?: PayHeaderType) => {
    setFormError({});
    setModalMode(mode);
    setFormData({
      name: "",
      code: "",
      description: "",
      type: "",
      category: "",
      amount: "",
    });
    setEditId(null);

    if (mode === "edit" && rec) {
      setFormData({
        name: rec.name,
        code: rec.code,
        description: rec.description,
        type: rec.type,
        category: rec.category,
        amount: rec.amount,
      });
      setEditId(rec.id);
    }

    const el = document.getElementById("payheader_modal");
    if (el) {
      const bsModal = (window as any).bootstrap.Modal.getOrCreateInstance(el);
      bsModal.show();
    }
  };

  // hide modal + backdrop cleanup
  const hideModal = (modalId: string) => {
    const el = document.getElementById(modalId);
    if (!el || !(window as any).bootstrap?.Modal) return;

    const instance = (window as any).bootstrap.Modal.getInstance(el);
    if (instance) {
      instance.hide();
    }

    // after fade, remove any stray backdrops & body locks
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }, 300);
  };

  // Handlers
  const handleAddInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "amount") {
      const isValid = /^\d*\.?\d{0,2}$/.test(value);
      if (!isValid) return;
    }
    // if (value.trim()) {
    //     setFormError({});
    // }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (value.trim() !== "") {
      setFormError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async () => {
    const errors: any = {};
    console.log("Form data:", formData);
    if (!formData.name.trim()) errors.name = "Name is required.";
    if (!formData.code.trim()) errors.code = "Code is required.";
    if (!formData.type) errors.type = "Type is required.";
    if (!formData.category) errors.category = "Category is required.";
    if (!String(formData.amount).trim()) errors.amount = "Amount is required.";

    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }
    try {
      const body: Record<string, any> = {
        name: formData.name.trim(),
        code: formData.code.trim(),
        description: formData.description.trim(),
        type: formData.type,
        category: formData.category,
        amount: String(formData.amount).trim(),
      };
      if (modalMode === "edit" && editId != null) body.id = editId;
      const res = await api<{ success: boolean; data: any; error?: string }>(
        "/save-payhead",
        {
          method: "POST",
          body,
        }
      );
      if (res.success) {
        if (modalMode === "edit") {
        await fetchPayHeader();
        } else {
          // For add mode:
          setTotalItems((prevCount) => {
            const newCount = prevCount + 1;
            const newTotalPages = Math.ceil(newCount / pageSize);
            // Set current page to last page
            setCurrentPage(newTotalPages);
            // Fetch data for new last page after page state updates
            fetchPayHeader();
            return newCount;
          });
        }

        hideModal("payheader_modal");
        toast.success(
          modalMode === "add"
            ? "Payheader added successfully!"
            : "Payheader updated successfully!"
        );
      } else {
        const msg = res.error?.toLowerCase().includes("duplicate")
          ? "Duplicate header! Payheader already exists."
          : res.error || "Failed to save payheader.";
        toast.error(msg);
      }
    } catch (err: any) {
            if (err.response?.data) {
              const data = err.response.data;
              const msg =
                data.error ||
                data.message ||
                err.message ||
                "Something went wrong.";
              toast.error(msg);
            } else {
              toast.error(err.message || "Something went wrong.");
            }
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const res = await api<{ success: boolean; error?: string }>(
        `/payhead/delete`,
        { method: "POST", body: { id } }
      );
      if (res.success) {
        setTotalItems((prevCount) => prevCount - 1);
        toast.success("Payheader deleted successfully!");
        // Calculate the total pages after deletion
        const totalPages = Math.ceil((totalItems - 1) / pageSize);
        // If the current page number is now greater than totalPages, move back one page
        if (currentPage > totalPages) {
          setCurrentPage(totalPages > 0 ? totalPages : 1);
        } else {
          await fetchPayHeader();
        }
      } else {
        toast.error(res.error || "Failed to delete payheader.");
      }
    } catch (err: any) {
        if (err.response?.data) {
          const data = err.response.data;
          const msg =
            data.error ||
            data.message ||
            err.message ||
            "Something went wrong.";
          toast.error(msg);
        } else {
          toast.error(err.message || "Something went wrong.");
        }
      }
  };

  const handleBlur = (
    e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    if (value.trim() === "") {
      setFormError((prev) => ({
        ...prev,
        [name]: `${name[0].toUpperCase() + name.slice(1)} is required.`,
      }));
    }
  };
  const openDeleteModal = (id: number) => {
    setDeleteId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };

  const columns = [
    {
      title: "Type",
      width: "10%",
      dataIndex: "type",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Category",
      width: "10%",
      dataIndex: "category",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Name",
      width: "20%",
      dataIndex: "name",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Code",
      width: "20%",
      dataIndex: "code",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Description",
      width: "20%",
      dataIndex: "description",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Amount",
      width: "10%",
      dataIndex: "amount",
      render: (t: string) => {
        return t;
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: any, rec: PayHeaderType) => (
        <div className="action-icon d-inline-flex">
          <Link to="#" onClick={() => openModal("edit", rec)}>
            <i className="ti ti-edit" />
          </Link>
          <Link to="#" onClick={() => openDeleteModal(rec.id)}>
            <i className="ti ti-trash" />
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
    <div className="page-wrapper d-flex flex-column">
      <div className="content flex-grow-1 " >
        <div className="card card-margin-bottom" ><div className="card-body p-0" id="payheader-list" style={{ height: tableHeight, display: "flex", flexDirection: "column" }}>
        <Table  style={{ flex: 1 }} loading={loading} currentPage={currentPage} dataSource={payHeader} columns={columns} onPageChange={setCurrentPage} totalItems={totalItems} pageSize={pageSize} />
      </div></div></div>

      {/* Add-Edit Modal */}
      <div className="modal fade" id="payheader_modal">
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {modalMode === "add" ? "Add Payhead" : "Edit Payhead"}
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => hideModal("payheader_modal")}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body pb-0">
              <div className="mb-3">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  onChange={handleAddInputChange}
                  onBlur={handleBlur}
                  value={formData.name}
                />
                {formError.name && (
                  <small className="text-danger">{formError.name}</small>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Code <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  onChange={handleAddInputChange}
                  onBlur={handleBlur}
                  value={formData.code}
                />
                {formError.code && (
                  <small className="text-danger">{formError.code}</small>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <input
                  type="text"
                  className="form-control"
                  name="description"
                  onChange={handleAddInputChange}
                  onBlur={handleBlur}
                  value={formData.description}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Type <span className="text-danger">*</span>
                </label>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="type-fixed"
                      name="type"
                      value="F"
                      onBlur={handleBlur}
                      onChange={handleAddInputChange}
                      checked={formData.type === "F"}
                    />
                    <label className="form-check-label" htmlFor="type-fixed">
                      Fixed
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="type"
                      value="P"
                      id="type-percentage"
                      checked={formData.type === "P"}
                      onChange={handleAddInputChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="type-percentage"
                    >
                      Percentage
                    </label>
                  </div>
                </div>
                {formError.type && (
                  <small className="text-danger">{formError.type}</small>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Category <span className="text-danger">*</span>
                </label>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      id="category-allowance"
                      type="radio"
                      name="category"
                      onBlur={handleBlur}
                      checked={formData.category === "A"}
                      value="A"
                      onChange={handleAddInputChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="category-allowance"
                    >
                      Allowance
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      id="category-deduction"
                      type="radio"
                      name="category"
                      value="D"
                      checked={formData.category === "D"}
                      onChange={handleAddInputChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="category-deduction"
                    >
                      Deduction
                    </label>
                  </div>
                </div>
                {formError.category && (
                  <small className="text-danger">{formError.category}</small>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Amount <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="amount"
                  onChange={handleAddInputChange}
                  onBlur={handleBlur}
                  value={formData.amount}
                  maxLength={5}
                />
                {formError.amount && (
                  <small className="text-danger">{formError.amount}</small>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-light me-2"
                onClick={() => hideModal("payheader_modal")}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                {editId ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div id="top-modal" className="modal fade" tabIndex={-1}>
        <div className="modal-dialog modal-top">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Delete Payhead</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this record?</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-cancel" data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => deleteId !== null && handleDelete(deleteId)}
                data-bs-dismiss="modal"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
    <ToastContainer position="top-right" autoClose={3000} /></>
  );
};
export default PayHeader;
